"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { create } from "zustand";
import { getActions } from "./actions.js";
const DEFAULT_USER_INFO_STATE = {
  auth: null,
  recoveryShare: null,
  pfpUrl: null,
  displayName: null
};
const useUserInfoStore = create((set, get) => __spreadValues(__spreadValues({}, DEFAULT_USER_INFO_STATE), getActions(set, get)));
export {
  DEFAULT_USER_INFO_STATE,
  useUserInfoStore
};
